import React from "react";

const Partners = () => {
	const partners = [
		{
			name: "African Leadership University",
			logo: "/assets/images/African-Leadership-University.png",
		},
		{
			name: "ALU School of Health",
			logo: "/assets/images/ALU-School-of-Health.jpg",
		},
		{
			name: "Healthtracka",
			logo: "/assets/images/Healthtracka.jpg",
		},
		{
			name: "RaiseHerVoice",
			logo: "/assets/images/RaiseHerVoice.jpg",
		},
		{
			name: "lightED",
			logo: "/assets/images/ligtED.jpg",
		},
		// {
		// 	name: "HER",
		// 	logo: "/assets/images/HER.jpg",
		// },
		// {
		// 	name: "Nexo Girls",
		// 	logo: "/assets/images/Nexo_Girls.jpg",
		// },
		// {
		// 	name: "Gurl Pod",
		// 	logo: "/assets/images/Gurl-Pod.jpg",
		// },
		{
			name: "Kosmotive",
			logo: "/assets/images/Kosmotive.jpg",
		},
	];

	// Duplicate partners for seamless carousel
	const duplicatedPartners = [...partners, ...partners, ...partners];

	return (
		<section className="bg-gray-50 py-16 lg:py-20 px-6">
			<div className="container">
				{/* Top Section - Title and Intro */}
				<div className="max-w-4xl mb-16">
					{/* Main Heading */}
					<h2 className="text-2xl lg:text-3xl xl:text-4xl font-light text-swift-dark leading-tight mb-6 font-generalSans">
						Together, We Drive long{" "}
						<span className="text-swift-pink">Lasting Impact</span>
					</h2>

					{/* Intro Paragraph */}
					<p className="text-l text-gray-600 font-light leading-relaxed font-generalSans">
						Swift Haven is supported by organizations that share our
						commitment to <br className="hidden md:block" />{" "}
						sustainability, innovation, and health equity for girls
						across Africa.
					</p>
				</div>

				{/* Bottom Section - Partner Logos Carousel */}
				<div className="relative overflow-hidden">
					<div
						className="flex animate-scroll"
						style={{
							animation: "scroll 30s linear infinite",
						}}
					>
						{duplicatedPartners.map((partner, index) => (
							<div
								key={index}
								className="flex-shrink-0 -mr-8"
								style={{ minWidth: "200px", height: "120px" }}
							>
								<div className="h-full w-full flex items-center justify-center rounded-lg">
									<img
										src={partner.logo}
										alt={partner.name}
										className="max-h-full max-w-full object-contain rounded-lg"
									/>
								</div>
							</div>
						))}
					</div>
				</div>

				<style jsx>{`
					@keyframes scroll {
						0% {
							transform: translateX(0);
						}
						100% {
							transform: translateX(
								-${partners.length * 200 + (partners.length - 1) * 24}px
							);
						}
					}
				`}</style>
			</div>
		</section>
	);
};

export default Partners;
